/* global System */
import withLazyUnveil from 'scripts/higher-order-components/withLazyUnveil'

export default {
  WertErmittlerStart: withLazyUnveil({
    loadComponent: () =>
      System.import(/* webpackChunkName: "WertErmittlerStart" */ './index'),
    height: 273,
    mobileHeight: 402,
  }),
}
